import { Components, Theme } from '@mui/material';

export const MuiAvatar: Components<Theme>['MuiAvatar'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      backgroundColor: theme.featureFlags.panwRebrandStubYear
        ? theme.palette.avatar.backgroundColor
        : theme.palette.primary.main,
      color: theme.featureFlags.panwRebrandStubYear
        ? theme.palette.avatar.textColor
        : theme.palette.primary.contrastText,
    }),
  },
};
